// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"bee9d653","216":"bee9d653"}[chunkId] + ".chunk.css";
};